<template>
  <div class="tf">
    <!-- username живёт в шапке карточки: в крошках он дублировался дважды -->
    <Breadcrumbs main="Пользователи" title="Карточка пользователя"/>

    <Modal name="UpdateMlbbMmr"
           title="Турнирный рейтинг MLBB"
           v-model="isShowMlbbMmrModal"
           :params="{ userId: user.id, username: user.username }"
           @submit="getAllData"/>

    <Modal name="UserDocuments"
           title="Верификация документов"
           v-model="isShowDocsModal"
           :size="'lg'"
           :params="{ userDocuments: userDocumentList,
                      isLoadingDocs: isLoadedUserDocs,
                      error: errorText }"/>

    <b-modal centered id="modal-edit-username" title="Изменить username"
             v-model="isShowEditUsernameModal" hide-footer>
      <label class="tf-label" for="edit-username-input">Новый username</label>
      <b-form-input id="edit-username-input" v-model="newUsername" :state="usernameInputState"
                    maxlength="20" @keyup.enter="confirmEditUsername"/>
      <div class="tf-hint">До 20 символов: латиница, цифры, «_» или «-».</div>
      <div v-if="editUsernameError" class="tf-err">{{ editUsernameError }}</div>
      <div class="d-flex justify-content-end mt-3">
        <button type="button" class="tf-btn-ghost mr-2" @click="isShowEditUsernameModal = false"
                :disabled="isUpdatingUsername">
          Отмена
        </button>
        <button type="button" class="tf-btn-primary" @click="confirmEditUsername"
                :disabled="isUpdatingUsername || !isUsernameValid">
          <i class="fa" :class="isUpdatingUsername ? 'fa-spinner' : 'fa-check'"></i>
          {{ isUpdatingUsername ? 'Сохраняем…' : 'Сохранить' }}
        </button>
      </div>
    </b-modal>

    <div class="container-fluid tf-wrap">

      <!-- ======================= шапка пользователя ======================= -->
      <div class="ui-hero">
        <button type="button" class="tf-back" @click="goBack" v-b-tooltip.hover.bottom="'К списку пользователей'">
          <i class="fa fa-arrow-left"></i>
        </button>

        <img class="ui-hero__avatar" :src="avatarUrl" alt=""
             @error="event => event.target.src = UserImagePug"/>

        <div class="ui-hero__title">
          <div class="ui-hero__name-row">
            <h1 class="ui-hero__name" :class="{ 'is-placeholder': !user.username }">
              {{ user.username || 'Пользователь' }}
            </h1>
            <span class="tf-badge" :class="isActivated ? 'tf-badge--ok' : 'tf-badge--warn'">
              <i class="fa" :class="isActivated ? 'fa-check' : 'fa-exclamation'"></i>
              {{ isActivated ? 'Активирован' : 'Не активирован' }}
            </span>
            <span class="tf-badge" :class="isGamer ? 'tf-badge--primary' : ''">
              <i class="fa fa-gamepad"></i> {{ isGamer ? 'Игровой' : 'Не игровой' }}
            </span>
            <span v-if="bans.length" class="tf-badge tf-badge--danger">
              <i class="fa fa-ban"></i> В бане
            </span>
          </div>

          <div class="ui-hero__meta">
            <button type="button" class="ui-copy" @click="copyValue(user.id, 'ID')"
                    v-b-tooltip.hover.bottom="'Скопировать ID'">
              ID {{ user.id || '—' }} <i class="fa fa-copy"></i>
            </button>
            <i class="tf-dot"></i>
            <button v-if="user.email" type="button" class="ui-copy" @click="copyValue(user.email, 'Email')"
                    v-b-tooltip.hover.bottom="'Скопировать почту'">
              {{ user.email }} <i class="fa fa-copy"></i>
            </button>
            <span v-else>почта не указана</span>
            <i class="tf-dot"></i>
            <span>{{ (user.country && user.country.name) || 'страна не указана' }}</span>
            <template v-if="user.slug">
              <i class="tf-dot"></i>
              <button type="button" class="ui-copy" @click="copyValue(user.slug, 'Slug')"
                      v-b-tooltip.hover.bottom="'Скопировать slug'">
                {{ user.slug }} <i class="fa fa-copy"></i>
              </button>
            </template>
          </div>
        </div>

        <dl class="ui-stats">
          <div>
            <dt>Команд</dt>
            <dd>{{ teams.length }}</dd>
          </div>
          <div>
            <dt>Профилей</dt>
            <dd>{{ gameProfiles.length }}</dd>
          </div>
          <div>
            <dt>Входов</dt>
            <dd>{{ userLoginLogsTotalPagination || 0 }}</dd>
          </div>
          <div>
            <dt>Рейтинг PUBG</dt>
            <dd>{{ pubgRating }}</dd>
          </div>
          <div v-if="hasMlbbGameProfile">
            <dt>MMR MLBB</dt>
            <dd>{{ mlbbMmr.value }}</dd>
          </div>
        </dl>

        <div class="ui-hero__actions">
          <button v-if="!isActivated && user.id" type="button" class="tf-btn-primary"
                  @click.prevent="activateUser">
            <i class="fa fa-bolt"></i> Активировать
          </button>
          <a v-if="user.slug" :href="publicPageUrl" target="_blank" rel="noopener" class="tf-btn-ghost">
            <i class="fa fa-external-link"></i> Публичная страница
          </a>
          <b-dropdown right no-caret variant="link" toggle-class="ui-kebab" menu-class="ui-menu"
                      title="Ещё действия">
            <template #button-content><i class="fa fa-ellipsis-h"></i></template>
            <b-dropdown-item @click="openEditUsernameModal">
              <i class="fa fa-pencil"></i> Изменить username
            </b-dropdown-item>
            <b-dropdown-item v-if="!user.email" :disabled="isRandomEmailLoading" @click="assignRandomEmail">
              <i class="fa fa-envelope-o"></i> Присвоить рандомную почту
            </b-dropdown-item>
            <b-dropdown-item v-if="user.is_random_email" link-class="ui-menu__danger"
                             :disabled="isRandomEmailLoading" @click="deleteRandomEmail">
              <i class="fa fa-trash-o"></i> Удалить почту
            </b-dropdown-item>
            <b-dropdown-divider/>
            <b-dropdown-item @click="getAllData">
              <i class="fa fa-refresh"></i> Обновить данные
            </b-dropdown-item>
          </b-dropdown>
        </div>

        <div v-if="randomEmailError" class="tf-err ui-hero__error">{{ randomEmailError }}</div>
      </div>

      <!-- ======================= загрузка ======================= -->
      <div v-if="isLoadingUser && !user.id" class="tf-card">
        <div class="tf-card__body">
          <div class="ui-skeleton">
            <div v-for="n in 6" :key="'sk' + n" class="ui-skeleton__row">
              <span class="ui-sk ui-sk--label"></span>
              <span class="ui-sk"></span>
            </div>
          </div>
        </div>
      </div>

      <template v-else>

        <!-- ======================= табы ======================= -->
        <div class="ui-tabs" ref="sectionTop">
          <button v-for="section in sections" :key="section.key" type="button"
                  class="ui-tab" :class="{ 'is-on': activeSection === section.key }"
                  @click="goSection(section.key)">
            <i class="fa" :class="section.icon"></i>
            <span>{{ section.label }}</span>
            <span v-if="section.count !== null" class="ui-count">{{ section.count }}</span>
          </button>
        </div>

        <div class="ui-main">

            <!-- ============ ОБЩЕЕ ============ -->
            <section v-show="activeSection === 'main'" class="tf-sec">

              <div v-if="bans.length" class="tf-alert mb-3">
                <i class="fa fa-ban tf-alert__icon"></i>
                <div class="tf-alert__body">
                  <div class="tf-alert__title">Активных банов: {{ bans.length }}</div>
                  <div v-for="ban in bans" :key="'ban' + ban.id" class="ui-ban">
                    <b>{{ ban.game_name || 'Профиль' }}</b>
                    <span>с {{ ban.from || '—' }} до {{ ban.to || '—' }}</span>
                    <em v-if="ban.description">{{ ban.description }}</em>
                  </div>
                </div>
              </div>

              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-id-badge"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Личные данные</h3>
                  </div>
                </div>
                <div class="tf-card__body">
                  <dl class="ui-dl">
                    <div>
                      <dt>ФИО</dt>
                      <dd>{{ user.full_name || '—' }}</dd>
                    </div>
                    <div>
                      <dt>Дата рождения</dt>
                      <dd>{{ formatDate(user.birthday) }}</dd>
                    </div>
                    <div>
                      <dt>Язык интерфейса</dt>
                      <dd>{{ (user.lang && user.lang.code) ? user.lang.code.toUpperCase() : '—' }}</dd>
                    </div>
                    <div>
                      <dt>Регистрация</dt>
                      <dd>{{ formatDateTime(user.created_at) }}</dd>
                    </div>
                  </dl>

                  <div v-if="levels.length" class="ui-levels">
                    <div class="tf-label">Уровень и опыт</div>
                    <div class="ui-levels__list">
                      <span v-for="level in levels" :key="'lvl' + level.id" class="ui-level">
                        <span class="ui-level__game">{{ level.game }}</span>
                        <span class="ui-level__num">{{ level.number }}</span>
                        <span class="ui-level__xp">{{ level.experience }} XP</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-users"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Команды</h3>
                    <p class="tf-card__sub">Составы, в которых состоит пользователь</p>
                  </div>
                  <span class="tf-badge">{{ pubgTeams.length + mlbbTeams.length }}</span>
                </div>
                <div class="tf-card__body">
                  <div class="tf-grid">
                    <div class="tf-field tf-field--6">
                      <div class="tf-label">PUBG Mobile</div>
                      <div v-if="pubgTeams.length" class="tf-links">
                        <button v-for="team in pubgTeams" :key="'pubg' + team.id" type="button"
                                class="tf-link" @click="showTeamInfo(team.id)">
                          <i class="fa fa-shield"></i> {{ team.name }}
                        </button>
                      </div>
                      <div v-else class="ui-muted">Команд нет</div>
                    </div>
                    <div class="tf-field tf-field--6">
                      <div class="tf-label">MLBB</div>
                      <div v-if="mlbbTeams.length" class="tf-links">
                        <button v-for="team in mlbbTeams" :key="'mlbb' + team.id" type="button"
                                class="tf-link" @click="showTeamInfo(team.id)">
                          <i class="fa fa-shield"></i> {{ team.name }}
                        </button>
                      </div>
                      <div v-else class="ui-muted">Команд нет</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-id-card-o"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Документы</h3>
                    <p class="tf-card__sub">Файлы, загруженные для верификации</p>
                  </div>
                  <span v-if="userDocumentList.length" class="tf-badge">{{ userDocumentList.length }}</span>
                </div>
                <div class="tf-card__body">
                  <div v-if="isLoadedUserDocs" class="ui-muted">
                    <i class="fa fa-spinner tf-spin"></i> Загружаем документы…
                  </div>
                  <div v-else-if="errorText" class="tf-alert tf-alert--warn mb-0">
                    <i class="fa fa-exclamation-triangle tf-alert__icon"></i>
                    <div class="tf-alert__body">{{ errorText }}</div>
                  </div>
                  <div v-else-if="userDocumentList.length" class="ui-docs">
                    <div v-for="file in userDocumentList" :key="'fileId' + file.id" class="ui-doc">
                      <button type="button" class="ui-doc__name" @click="isShowDocsModal = true">
                        <i class="fa fa-file-image-o"></i> {{ file.name }}
                      </button>
                      <button type="button" class="tf-icon-btn ui-doc__del"
                              @click="removeDocument(file)" v-b-tooltip.hover.top="'Удалить документ'">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </div>
                  </div>
                  <div v-else class="ui-muted">Нет загруженных документов</div>
                </div>
              </div>
            </section>

            <!-- ============ ИГРОВЫЕ ПРОФИЛИ ============ -->
            <section v-show="activeSection === 'profiles'" class="tf-sec">
              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-gamepad"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Игровые профили</h3>
                    <p class="tf-card__sub">Ник и игровой ID по каждой дисциплине</p>
                  </div>
                  <span class="tf-badge">{{ userProfilesForWork.length }}</span>
                </div>
                <div class="tf-card__body">
                  <div v-if="!userProfilesForWork.length" class="ui-muted mb-3">
                    Игровых профилей нет — добавьте нужную дисциплину.
                  </div>

                  <game_profiles
                      v-for="gameProfile in userProfilesForWork"
                      :key="'gameProfile-' + (gameProfile.id || gameProfile.game.slug)"
                      @submit="getAllData"
                      :game="gameProfile"
                  />

                  <div class="ui-add">
                    <!-- MMR живёт отдельно от полей профиля: он привязан к игровому ID,
                         а не к аккаунту, и правится своей ручкой с обязательной причиной. -->
                    <button v-if="hasMlbbGameProfile" type="button" class="tf-btn-ghost"
                            @click="isShowMlbbMmrModal = true">
                      <i class="fa fa-pencil"></i> Изменить MMR (MLBB)
                    </button>
                    <button v-if="isShowAddGameProfilePubgMobile" type="button" class="tf-btn-ghost"
                            @click="addPubgMobileGameProfile">
                      <i class="fa fa-plus"></i> Профиль PUBG MOBILE
                    </button>
                    <button v-if="isShowAddGameProfileMLBB" type="button" class="tf-btn-ghost"
                            @click="addMlbbGameProfile">
                      <i class="fa fa-plus"></i> Профиль MLBB
                    </button>
                  </div>
                </div>
              </div>
            </section>

            <!-- ============ АККАУНТЫ ============ -->
            <section v-show="activeSection === 'accounts'" class="tf-sec">
              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-link"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Аккаунты и верификация</h3>
                    <p class="tf-card__sub">Привязанные соцсети и контакты</p>
                  </div>
                  <span class="tf-badge">{{ accounts.length }}</span>
                </div>
                <div class="tf-card__body">
                  <div v-if="!accounts.length" class="ui-muted">Привязанных аккаунтов нет</div>

                  <div v-else class="ui-accounts">
                    <div v-for="account in accounts" :key="account.name" class="ui-account">
                      <div class="ui-account__head">
                        <span class="ui-account__name">{{ account.name }}</span>
                        <span v-if="account.isPrimary" class="tf-badge tf-badge--primary">основной</span>
                        <span class="tf-topbar__spacer"></span>
                        <button v-if="!account.isPrimary" type="button" class="tf-icon-btn ui-account__unlink"
                                @click="unlinkSocialAccount(account.id, $route.params.id)"
                                v-b-tooltip.hover.top="'Отвязать аккаунт'">
                          <i class="fa fa-chain-broken"></i>
                        </button>
                      </div>
                      <dl class="ui-dl ui-dl--tight">
                        <div>
                          <dt>Никнейм</dt>
                          <dd>
                            <a v-if="account.name === 'telegram' && account.link" :href="account.link"
                               target="_blank" rel="noopener">@{{ telegramNick(account.link) }}</a>
                            <a v-else-if="account.nickname" :href="account.link" target="_blank" rel="noopener">
                              {{ account.nickname }}
                            </a>
                            <span v-else class="ui-muted">—</span>
                          </dd>
                        </div>
                        <div>
                          <dt>Почта / номер</dt>
                          <dd>{{ account.email || account.phone || '—' }}</dd>
                        </div>
                        <div>
                          <dt>Страна</dt>
                          <dd>{{ account.country || '—' }}</dd>
                        </div>
                        <div>
                          <dt>Верифицирован</dt>
                          <dd>{{ account.verifiedDate || '—' }}</dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <!-- ============ ЛОГИ ============ -->
            <section v-show="activeSection === 'logs'" class="tf-sec">
              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-history"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Логи действий</h3>
                  </div>
                </div>
                <div class="tf-card__body ui-flush">
                  <UserLogs/>
                </div>
              </div>
            </section>

            <!-- ============ IP ============ -->
            <section v-show="activeSection === 'ip'" class="tf-sec">
              <div class="tf-card">
                <div class="tf-card__head">
                  <span class="tf-card__icon"><i class="fa fa-sign-in"></i></span>
                  <div class="tf-card__titles">
                    <h3 class="tf-card__title">Входы и устройства</h3>
                  </div>
                </div>
                <div class="tf-card__body ui-flush">
                  <div v-if="!loginRows.length" class="ui-empty">
                    <i class="fa fa-sign-in"></i>
                    <div class="ui-empty__title">Входов нет</div>
                    <div class="ui-empty__text">История авторизаций появится здесь</div>
                  </div>

                  <div v-else class="ui-table-wrap">
                    <table class="ui-table">
                      <thead>
                      <tr>
                        <th>Дата</th>
                        <th>IP</th>
                        <th>Страна</th>
                        <th>Устройство</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="log in loginRows" :key="'ip' + log.id">
                        <td>
                          <div class="ui-time">
                            <span>{{ formatDateTime(log.created_at) }}</span>
                            <small>{{ formatRelative(log.created_at) }}</small>
                          </div>
                        </td>
                        <td>
                          <button type="button" class="ui-copy ui-mono" @click="copyValue(log.ip, 'IP')">
                            {{ log.ip || '—' }} <i class="fa fa-copy"></i>
                          </button>
                        </td>
                        <td>{{ log.x_country || '—' }}</td>
                        <!-- устройство, браузер и платформа читаются вместе -->
                        <td>
                          <div class="ui-device">
                            <span>{{ log.x_device || '—' }}</span>
                            <small v-if="log.x_browser || log.x_platform">
                              {{ [log.x_browser, log.x_platform].filter(Boolean).join(' · ') }}
                            </small>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <div v-if="loginRows.length" class="ui-foot ui-foot--bordered">
                    <b-pagination
                        class="ui-pagination my-0"
                        v-model="loginPageModel"
                        :total-rows="userLoginLogsTotalPagination"
                        :per-page="10"
                        :limit="7"
                        @change="handlePageChange"
                    />
                  </div>
                </div>
              </div>
            </section>
          </div>

      </template>
    </div>
  </div>
</template>


<script>
import {UsersAdapterMixin} from "@/mixins/Users/UsersAdapterMixin";
import {TeamsAdapterMixin} from "@/mixins/Teams/TeamsAdapterMixin";
import {PaginationHelperMixin} from "@/mixins/Helpers/PaginationHelperMixin";
import game_profiles from "@/components/game_profiles";
import Modal from '@/components/modals/index.vue'
import api from "@/api/api";
import Vue from "vue";
import UserImagePug from '@/assets/images/pugs/team.png'
import UserLogs from "@/components/User/UserLogs";
import Env from '../../../env'

export default {
  name: 'UserInfo',
  mixins: [UsersAdapterMixin, TeamsAdapterMixin, PaginationHelperMixin],
  components: {game_profiles, Modal, UserLogs},
  data() {
    return {
      UserImagePug,
      pageKey: 'pageNumberUserLoginLogs',
      activeSection: 'main',
      stickyFrame: null,

      isLoadingUser: false,
      isShowDocsModal: false,
      isShowMlbbMmrModal: false,
      newGameProfiles: [],
      userDocumentList: [],
      isLoadedUserDocs: false,
      errorText: null,

      isRandomEmailLoading: false,
      randomEmailError: null,

      isShowEditUsernameModal: false,
      isUpdatingUsername: false,
      newUsername: '',
      editUsernameError: null,
      usernameRegex: /^[a-zA-Z0-9_-]+$/,
    }
  },
  computed: {
    /** Стор кладёт в showUser пустой массив до загрузки — приводим к объекту, чтобы шаблон не падал. */
    user() {
      const raw = this.userShow;
      return raw && !Array.isArray(raw) ? raw : {};
    },

    sections() {
      return [
        {key: 'main', label: 'Общее', icon: 'fa-user-o', count: null},
        {key: 'profiles', label: 'Игровые профили', icon: 'fa-gamepad', count: this.userProfilesForWork.length},
        {key: 'accounts', label: 'Аккаунты', icon: 'fa-link', count: this.accounts.length},
        {key: 'logs', label: 'Логи', icon: 'fa-history', count: null},
        {key: 'ip', label: 'Входы и IP', icon: 'fa-sign-in', count: this.userLoginLogsTotalPagination || null},
      ];
    },

    avatarUrl() {
      return (this.user.avatar && this.user.avatar.original_url) || UserImagePug;
    },

    publicPageUrl() {
      const isTest = Env.API_URL.includes('backendtest');
      const baseUrl = isTest ? 'https://front.bigplay.gg' : 'https://bigplay.gg';
      return `${baseUrl}/user/${this.user.slug}`;
    },

    gameProfiles() {
      return this.user.gameProfiles || [];
    },

    userProfilesForWork() {
      return [...this.gameProfiles, ...this.newGameProfiles];
    },

    bans() {
      return this.user.currentBans || [];
    },

    isGamer() {
      return this.gameProfiles.length > 0;
    },

    isActivated() {
      return Number(this.userSocialAccountsShow) > 0;
    },

    /** Миксин обращается к userShow.socialAccounts напрямую — не трогаем его, пока данных нет. */
    accounts() {
      if (!this.user.socialAccounts) return [];
      return this.socialAccounts || [];
    },

    teams() {
      return this.user.teams || [];
    },

    pubgTeams() {
      return this.teams.filter(team => team.game_id === 1);
    },

    mlbbTeams() {
      return this.teams.filter(team => team.game_id === 3);
    },

    pubgRating() {
      const rating = this.user.ratingPubgMobile && this.user.ratingPubgMobile.rating;
      return rating === null || rating === undefined ? '—' : rating;
    },

    // MMR приходит в игровом профиле MLBB: gameProfiles[].mlbb_player_rating.
    // null — у профиля ещё нет рейтинга (MLBB ID не привязан или матчей не было).
    mlbbMmr() {
      const profile = this.gameProfiles.find(item => item && (item.game_id === 3 || (item.game && item.game.slug === 'mlbb')));
      const rating = profile && profile.mlbb_player_rating;
      if (rating === null || rating === undefined) return {value: '—', division: null};
      if (typeof rating === 'number') return {value: rating, division: null};
      return {
        value: rating.mmr != null ? rating.mmr : '—',
        division: rating.division != null ? rating.division : null,
      };
    },

    levels() {
      return this.gameProfiles
          .filter(profile => profile && profile.level)
          .map(profile => ({
            id: profile.id,
            game: (profile.game && profile.game.name) || '—',
            number: profile.level.number != null ? profile.level.number : '—',
            experience: profile.experience_points != null ? profile.experience_points : 0,
          }));
    },

    loginRows() {
      return (this.userLoginLogs || []).map(log => ({
        ...log,
        x_country: (log.country && log.country.name) || '',
        x_device: (log.data && log.data.device) || '',
        x_browser: (log.data && log.data.browser) || '',
        x_platform: (log.data && log.data.platform) || '',
      }));
    },

    loginPageModel: {
      get() {
        return Number(this.userLoginLogsCurrentPage) || 1;
      },
      set(value) {
        this.userLoginLogsCurrentPage = value;
      },
    },

    isShowAddGameProfilePubgMobile() {
      return !this.userProfilesForWork.find(profile => profile.game && profile.game.slug === 'pubg-mobile');
    },

    /** Без привязанного профиля MLBB рейтинга у игрока нет — и править нечего. */
    hasMlbbGameProfile() {
      return !!this.userProfilesForWork.find(profile => profile.game && profile.game.slug === 'mlbb' && profile.id);
    },
    isShowAddGameProfileMLBB() {
      return !this.userProfilesForWork.find(profile => profile.game && profile.game.slug === 'mlbb');
    },

    isUsernameValid() {
      const value = this.newUsername;
      return typeof value === 'string'
          && value.length > 0
          && value.length <= 20
          && this.usernameRegex.test(value);
    },

    usernameInputState() {
      if (!this.newUsername) return null;
      return this.isUsernameValid;
    },
  },
  created() {
    this.getAllData();
    this.loadDocuments();
  },
  mounted() {
    this.updateStickyOffsets();
    window.addEventListener('resize', this.updateStickyOffsets);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateStickyOffsets);
    if (this.stickyFrame) cancelAnimationFrame(this.stickyFrame);
  },
  methods: {
    /** Шапка приложения фиксированная и её высота зависит от темы — считаем оффсет по факту. */
    updateStickyOffsets() {
      if (this.stickyFrame) return;
      this.stickyFrame = requestAnimationFrame(() => {
        this.stickyFrame = null;
        if (!this.$el || !this.$el.style) return;
        const appHeader = document.querySelector('.page-header');
        const headerHeight = appHeader ? Math.round(appHeader.getBoundingClientRect().height) : 0;
        this.$el.style.setProperty('--tf-sticky-top', headerHeight + 'px');
      });
    },

    goSection(key) {
      this.activeSection = key;
      this.$nextTick(() => {
        const anchor = this.$refs.sectionTop;
        if (!anchor || !anchor.getBoundingClientRect) return;
        const appHeader = document.querySelector('.page-header');
        const headerHeight = appHeader ? Math.round(appHeader.getBoundingClientRect().height) : 0;
        const top = anchor.getBoundingClientRect().top + window.pageYOffset - headerHeight - 8;
        window.scrollTo({top: Math.max(top, 0), behavior: 'smooth'});
      });
    },

    copyValue(value, label) {
      if (value === null || value === undefined || value === '') return;
      const text = String(value);
      const done = () => this.$toasted.success(`${label} скопирован`, {position: 'top-right', duration: 1500});
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(done).catch(() => {
        });
        return;
      }
      const area = document.createElement('textarea');
      area.value = text;
      document.body.appendChild(area);
      area.select();
      try {
        document.execCommand('copy');
        done();
      } finally {
        document.body.removeChild(area);
      }
    },

    goBack() {
      this.$router.push({name: 'users_real'});
    },

    async getAllData() {
      this.isLoadingUser = true;
      try {
        await this.showUser(this.$route.params.id);
        // страницу берём из хранилища ДО записи, иначе затрём её текущим значением
        const page = Number(this.getCurrentPageNumber(this.pageKey)) || 1;
        this.recordPageToStorage(page, this.pageKey);
        await this.grabUserLoginLogs({
          pageNumber: page,
          userId: this.$route.params.id,
        });
      } catch (e) {
        this.$toasted.error("Не удалось загрузить пользователя", {position: 'top-right', duration: 3000});
      } finally {
        this.isLoadingUser = false;
      }
      this.newGameProfiles = [];
    },

    /** Документы доступны не всем ролям — ошибку показываем текстом, а не падением. */
    async loadDocuments() {
      this.isLoadedUserDocs = true;
      this.errorText = null;
      try {
        const response = await api.docs.showUserDocs(this.$route.params.id);
        this.userDocumentList = (response && response.data && response.data.user_documents) || [];
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message;
        this.errorText = message ? `Документы недоступны: ${message}` : 'Не удалось загрузить документы';
        this.userDocumentList = [];
      } finally {
        this.isLoadedUserDocs = false;
      }
    },

    handlePageChange(pageNumber) {
      this.recordPageToStorage(pageNumber, this.pageKey);
      this.grabUserLoginLogs({
        pageNumber: pageNumber,
        userId: this.$route.params.id,
      });
    },

    activateUser() {
      this.changeStatus({userId: this.user.id});
    },

    async removeDocument(file) {
      const confirmed = await this.$bvModal.msgBoxConfirm(`Удалить документ «${file.name}»?`, {
        title: 'Удаление документа',
        okTitle: 'Удалить',
        cancelTitle: 'Отмена',
        okVariant: 'danger',
        centered: true,
      });
      if (!confirmed) return;

      try {
        await api.docs.delete(file.id);
        Vue.toasted.success('Документ успешно удалён', {duration: 3000});
        this.userDocumentList = this.userDocumentList.filter(doc => doc.id !== file.id);
      } catch (error) {
        const message = error && error.response && error.response.data && error.response.data.message;
        Vue.toasted.error(message || 'Не удалось удалить документ', {duration: 3000});
      }
    },

    addPubgMobileGameProfile() {
      this.newGameProfiles.push({
        user_id: this.user.id,
        game_id: 1,
        game: {slug: 'pubg-mobile', name: 'PUBG MOBILE'},
        fields: {pubg_id: '', nick: ''},
      });
      this.goSection('profiles');
    },

    addMlbbGameProfile() {
      this.newGameProfiles.push({
        user_id: this.user.id,
        game_id: 3,
        game: {slug: 'mlbb', name: 'MLBB'},
        fields: {mlbb_id: '', nick: ''},
      });
      this.goSection('profiles');
    },

    telegramNick(link) {
      return String(link).split('/').filter(Boolean).pop();
    },

    openEditUsernameModal() {
      this.newUsername = this.user.username || '';
      this.editUsernameError = null;
      this.isShowEditUsernameModal = true;
    },

    async confirmEditUsername() {
      if (!this.isUsernameValid || this.isUpdatingUsername) return;
      this.isUpdatingUsername = true;
      this.editUsernameError = null;
      try {
        await api.users.updateUsername(this.$route.params.id, this.newUsername);
        this.isShowEditUsernameModal = false;
        Vue.toasted.success('Username успешно обновлён', {duration: 3000});
        await this.showUser(this.$route.params.id);
      } catch (error) {
        const data = error && error.response && error.response.data;
        const errors = data && data.errors;
        if (errors && typeof errors === 'object') {
          const first = Object.values(errors).find(value => Array.isArray(value) && value.length);
          this.editUsernameError = first ? first[0] : ((data && data.message) || 'Не удалось обновить username');
        } else {
          this.editUsernameError = (data && data.message) || 'Не удалось обновить username';
        }
      } finally {
        this.isUpdatingUsername = false;
      }
    },

    /** Ошибку по почте бэк отдаёт то массивом в errors.email, то строкой в message. */
    getEmailErrorMessage(error, fallback) {
      const data = error && error.response && error.response.data;
      const emailError = data && data.errors && data.errors.email;
      if (Array.isArray(emailError) && emailError.length) return emailError[0];
      if (typeof emailError === 'string' && emailError) return emailError;
      return (data && data.message) || fallback;
    },

    async assignRandomEmail() {
      if (this.isRandomEmailLoading) return;
      this.isRandomEmailLoading = true;
      this.randomEmailError = null;
      try {
        await api.users.assignRandomEmail(this.$route.params.id);
        Vue.toasted.success('Рандомная почта успешно присвоена', {duration: 3000});
        await this.showUser(this.$route.params.id);
      } catch (error) {
        this.randomEmailError = this.getEmailErrorMessage(error, 'Не удалось присвоить рандомную почту');
      } finally {
        this.isRandomEmailLoading = false;
      }
    },

    async deleteRandomEmail() {
      if (this.isRandomEmailLoading) return;
      this.isRandomEmailLoading = true;
      this.randomEmailError = null;
      try {
        await api.users.deleteRandomEmail(this.$route.params.id);
        Vue.toasted.success('Рандомная почта успешно удалена', {duration: 3000});
        await this.showUser(this.$route.params.id);
      } catch (error) {
        this.randomEmailError = this.getEmailErrorMessage(error, 'Не удалось удалить почту');
      } finally {
        this.isRandomEmailLoading = false;
      }
    },

    formatDate(value) {
      if (!value) return "—";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "—";
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
    },

    formatDateTime(value) {
      if (!value) return "—";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "—";
      const pad = (n) => String(n).padStart(2, "0");
      return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },

    formatRelative(value) {
      if (!value) return "";
      const date = new Date(String(value).replace(" ", "T"));
      if (isNaN(date.getTime())) return "";
      const minutes = Math.round((Date.now() - date.getTime()) / 60000);
      if (minutes < 1) return "только что";
      if (minutes < 60) return `${minutes} мин. назад`;
      const hours = Math.round(minutes / 60);
      if (hours < 24) return `${hours} ч. назад`;
      const days = Math.round(hours / 24);
      if (days < 30) return `${days} дн. назад`;
      return `${Math.round(days / 30)} мес. назад`;
    },
  },
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/tournament-form.scss";

/* ---------- горизонтальные табы ---------- */
.ui-tabs {
  position: sticky;
  top: var(--tf-sticky-top, 0px);
  z-index: 8;
  display: flex;
  gap: 4px;
  overflow-x: auto;
  padding: 6px;
  margin-bottom: 16px;
  background: var(--tf-bg);
  border: 1px solid var(--tf-border);
  border-radius: var(--tf-radius);
  box-shadow: var(--tf-shadow);
}

.ui-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: var(--tf-text);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background .14s ease, color .14s ease;

  > i:first-child { color: var(--tf-muted); font-size: 13px; }

  &:hover { background: var(--tf-soft); }

  &.is-on {
    background: var(--tf-primary-soft);
    color: var(--tf-primary);

    > i:first-child { color: var(--tf-primary); }
  }
}

/* ---------- одна колонка контента ---------- */
.ui-main { min-width: 0; }

/* ---------- шапка пользователя ---------- */
.ui-hero {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  padding: 14px 16px;
  margin-bottom: 12px;
  background: var(--tf-bg);
  border: 1px solid var(--tf-border);
  border-radius: var(--tf-radius);
  box-shadow: var(--tf-shadow);

  &__avatar {
    flex: 0 0 auto;
    width: 56px;
    height: 56px;
    border-radius: 18px;
    object-fit: cover;
    background: var(--tf-soft);
  }

  &__title { min-width: 0; flex: 1 1 280px; }

  &__name-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  &__name {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: var(--tf-text);
    word-break: break-word;

    &.is-placeholder { color: var(--tf-muted); font-weight: 500; }
  }

  &__meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 4px;
    font-size: 11.5px;
    color: var(--tf-muted);
  }

  &__actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: auto;
  }

  &__error { flex: 1 1 100%; margin: 0; }
}

/* ---------- цифры пользователя ---------- */
.ui-stats {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;

  > div {
    min-width: 96px;
    padding: 7px 12px;
    border-radius: 12px;
    background: var(--tf-soft);
  }

  dt {
    margin: 0;
    font-size: 11px;
    font-weight: 500;
    color: var(--tf-muted);
    white-space: nowrap;
  }

  dd {
    margin: 2px 0 0;
    font-size: 15px;
    font-weight: 600;
    color: var(--tf-text);
  }
}

@media (max-width: 767px) {
  .ui-hero__actions { margin-left: 0; width: 100%; }

  .ui-stats > div { flex: 1 1 calc(50% - 8px); }
}

/* ---------- меню «ещё действия» ---------- */
.ui-hero ::v-deep .ui-kebab {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 1px solid var(--tf-border);
  border-radius: 10px;
  background: var(--tf-bg);
  color: var(--tf-muted);

  &:hover, &:focus { border-color: var(--tf-primary); color: var(--tf-primary); box-shadow: none; }
}

.ui-hero ::v-deep .ui-menu {
  min-width: 232px;
  padding: 6px;
  border: 1px solid var(--tf-border);
  border-radius: 12px;
  box-shadow: var(--tf-shadow-lg);

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 9px;
    padding: 8px 10px;
    font-size: 13px;
    color: var(--tf-text);

    &:hover { background: var(--tf-soft); }

    i { width: 14px; color: var(--tf-muted); text-align: center; }
  }

  .ui-menu__danger {
    color: var(--tf-danger);

    i { color: var(--tf-danger); }

    &:hover { background: var(--tf-danger-soft); color: var(--tf-danger); }
  }
}

.ui-flush { padding: 0; }

/* ---------- список «ключ — значение» ---------- */
.ui-dl {
  margin: 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 0 24px;

  > div {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 0;
    border-bottom: 1px dashed var(--tf-border);
  }

  dt {
    margin: 0;
    font-size: 12px;
    font-weight: 500;
    color: var(--tf-muted);
    white-space: nowrap;
  }

  dd {
    margin: 0;
    font-size: 13px;
    text-align: right;
    color: var(--tf-text);
    word-break: break-word;
  }

  &--tight > div { padding: 7px 0; }

  &--stack {
    grid-template-columns: minmax(0, 1fr);
    margin-top: 14px;
    text-align: left;

    > div:last-child { border-bottom: 0; }
  }
}

.ui-email-error {
  margin-top: 10px;
  text-align: left;
}

.ui-btn-danger {
  border-color: var(--tf-danger);
  color: var(--tf-danger) !important;

  &:hover { background: var(--tf-danger-soft); border-color: var(--tf-danger); color: var(--tf-danger) !important; }
}

.ui-copy {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 0;
  background: none;
  padding: 0;
  color: inherit;
  font-size: inherit;
  cursor: pointer;
  word-break: break-all;

  i { opacity: 0; font-size: 10px; transition: opacity .14s ease; }

  &:hover {
    color: var(--tf-primary);

    i { opacity: 1; }
  }
}

.ui-mono { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 12.5px; }

.ui-muted { color: var(--tf-muted); font-size: 13px; }

.ui-count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 19px;
  height: 19px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--tf-soft-2);
  color: var(--tf-muted);
  font-size: 10.5px;
  font-weight: 700;
}

.ui-tab.is-on .ui-count {
  background: var(--tf-primary);
  color: #fff;
}

/* ---------- бан ---------- */
.ui-ban {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 8px;
  margin-top: 6px;
  font-size: 12.5px;
  color: var(--tf-text);

  b { color: var(--tf-danger); }

  em { font-style: normal; color: var(--tf-muted); }
}

/* ---------- уровни ---------- */
.ui-levels {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--tf-border);

  &__list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
}

.ui-level {
  display: inline-flex;
  align-items: baseline;
  gap: 7px;
  padding: 4px 11px;
  border: 1px solid var(--tf-border);
  border-radius: 10px;
  background: var(--tf-soft);

  &__game {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: var(--tf-muted);
  }

  &__num {
    font-size: 14px;
    font-weight: 700;
    color: var(--tf-primary);
  }

  &__xp { font-size: 11px; color: var(--tf-muted); }
}

/* ---------- документы ---------- */
.ui-docs {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.ui-doc {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid var(--tf-border);
  border-radius: 10px;
  background: var(--tf-soft);

  &__name {
    flex: 1 1 auto;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    border: 0;
    background: none;
    padding: 0;
    text-align: left;
    color: var(--tf-text);
    font-size: 13px;
    cursor: pointer;

    &:hover { color: var(--tf-primary); }
  }

  &__del:hover {
    border-color: var(--tf-danger);
    color: var(--tf-danger);
  }
}

/* ---------- аккаунты ---------- */
.ui-accounts {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 12px;
}

.ui-account {
  border: 1px solid var(--tf-border);
  border-radius: 12px;
  padding: 12px 14px;
  background: var(--tf-soft);

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
  }

  &__name {
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
    color: var(--tf-text);
  }

  &__unlink:hover {
    border-color: var(--tf-danger);
    color: var(--tf-danger);
  }

  .ui-dl { grid-template-columns: minmax(0, 1fr); }

  .ui-dl > div:last-child { border-bottom: 0; }
}

.ui-add {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 18px;
}

/* ---------- таблица входов ---------- */
.ui-table-wrap { overflow-x: auto; }

.ui-table {
  width: 100%;
  border-collapse: collapse;

  th {
    padding: 11px 16px;
    border-bottom: 1px solid var(--tf-border);
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .05em;
    color: var(--tf-muted);
    text-align: left;
    white-space: nowrap;
  }

  td {
    padding: 11px 16px;
    border-bottom: 1px solid var(--tf-border);
    font-size: 13px;
    color: var(--tf-text);
    vertical-align: middle;
  }

  tbody tr:last-child td { border-bottom: 0; }

  tbody tr:hover td { background: var(--tf-soft); }
}

.ui-time {
  display: flex;
  flex-direction: column;
  white-space: nowrap;

  small { font-size: 11px; color: var(--tf-muted); }
}

.ui-device {
  display: flex;
  flex-direction: column;

  small { font-size: 11px; color: var(--tf-muted); }
}

.ui-empty {
  padding: 34px 16px;
  text-align: center;
  color: var(--tf-muted);

  > i { font-size: 22px; opacity: .6; }

  &__title { margin-top: 10px; font-size: 14px; font-weight: 600; color: var(--tf-text); }

  &__text { margin-top: 2px; font-size: 12.5px; }
}

.ui-foot {
  display: flex;
  justify-content: flex-end;
  padding: 13px 16px;

  &--bordered {
    border-top: 1px solid var(--tf-border);
    background: var(--tf-soft);
  }
}

.ui-pagination ::v-deep {
  .page-item .page-link {
    border: 0;
    margin: 0 2px;
    min-width: 34px;
    height: 34px;
    line-height: 34px;
    padding: 0;
    text-align: center;
    border-radius: 9px;
    color: var(--tf-muted);
    background: transparent;
    font-size: 13px;
  }

  .page-item .page-link:hover { background: var(--tf-soft-2); color: var(--tf-primary); }

  .page-item.active .page-link {
    background: var(--tf-primary);
    color: #fff !important;
  }

  .page-item.disabled .page-link { opacity: .4; }
}

/* ---------- скелетон ---------- */
.ui-skeleton__row {
  display: grid;
  grid-template-columns: 180px minmax(0, 1fr);
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid var(--tf-border);

  &:last-child { border-bottom: 0; }
}

.ui-sk {
  height: 14px;
  border-radius: 7px;
  background: linear-gradient(90deg, var(--tf-soft) 25%, var(--tf-soft-2) 37%, var(--tf-soft) 63%);
  background-size: 400% 100%;
  animation: ui-shimmer 1.3s ease infinite;

  &--label { height: 12px; }
}

@keyframes ui-shimmer {
  0% { background-position: 100% 50%; }
  100% { background-position: 0 50%; }
}
</style>
